import { Component, Inject, OnInit } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-document-move-dialog',
  templateUrl: './document-move-dialog.component.html',
  styleUrls: ['./document-move-dialog.component.scss']
})
export class DocumentMoveDialogComponent implements OnInit {

  public selectedFolder: any;
  public folders = this.data

  constructor(
    public matDialogRef: MatDialogRef<DocumentMoveDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any[]
  ) { }

  ngOnInit() {
  }

  selectFolder(folder_id){

    this.selectedFolder = this.folders.find((e)=>{
      return e.id === folder_id
    })

  }
}
